<template>
  <!-- TODO handle i18n -->
  <div id="app" class="cb-hp cb-hp--hidden" tabindex="0" lang="en">
    <div class="cb-hp__wrapper">
      <div ref="parent" class="cb-header cb-transition__slide" id="cb-header">
        <component :is="headerType" :edit-mode="editMode" v-cb-slide="{ isnew : isNewHeader , ref: $refs.parent }">
        </component>
      </div>
      <div class="cb-body" id="cb-body" v-if="hp_partially_loaded" role="main">
        <transition :name = "current_notification && current_notification.isDismissible ? 'fade' : 'scale-down-y'">
          <cb-modal :icon="current_notification.type" :show-icon="current_notification.showIcon" :text="current_notification.message" v-if="showNotification" :is-dismissible="current_notification.isDismissible" @clearModalDialog="showNotification = false">
          </cb-modal>
        </transition>
        <cb-loader v-if="showLoader"></cb-loader>
        <router-view v-cb-animate='true'></router-view>
      </div>
    </div>
    <div class="cb-hp__close" @click="close" v-cb-link = "'shadow'" role="button" aria-label="close checkout" data-cb-id="cb_close" v-on:keydown="closeKey">
      <i class="icon-remove cb-hp__close-icon"></i>
    </div>
  </div>
</template>
<style src="@/assets/styles/app.styl" lang="stylus"></style>
<style src="@/assets/styles/checkout.styl" lang="stylus"></style>
<style src="@/assets/styles/base/_fonts.styl" lang="stylus" scoped></style>
<script>
import axios from 'axios'
import {
    mapGetters
} from "vuex"
import Type1 from "@/components/collections/headers/Type1"
import Type2 from "@/components/collections/headers/Type2"
import Type3 from "@/components/collections/headers/Type3"
import ThankYouHeader from "@/components/collections/headers/PaynowThankYouHeader"
import ModalBox from "@/components/collections/elements/ModalBox"
import CBNotification from "@/models/cb-notification"
import Loader from "@/components/collections/elements/Loader"
import { ToastNotificationTimeout } from "@/utils/helper-functions"

export default {
  name: 'PaynowCheckout',
  data() {
    return {
      transitionName: "",
      errMessage: "",
      showNotification: false,
      isNewHeader:false,
      prevHeader: "",
      currentheader: "",
      showLoader: false,
    }
  },
  created() {
  },
  mounted() {
      this.transitionName = "fade";
      document.body.addEventListener("keydown", (event) => {
        if (event.keyCode == 27) {
          this.close();
        }
      });
  },
  methods: {
    // TODO DRY the code
    close() {
      if(this.$route.name == "thankyou") {
        this.$store.dispatch('reset_unpaid_invoices');  
      }
      this.$store.dispatch('set_modal', false);
      this.$router.replace({
        name: "main"
      });
    },
    closeKey(event) {
      if(event.keyCode == 9) {
        document.getElementById("app").focus();
      }
    }
  },
  computed: {
    ...mapGetters(
      [
          'authenticated',
          'hp_partially_loaded',
          'authType',
          'current_notification',
          'set_loader'
      ]
    ),
    headerType() {
      this.isNewHeader = false;
      this.currentHeader = this.$route.meta.headerType ? this.$route.meta.headerType(this.$route) : this.$route.meta.header;
      if(this.currentHeader != "header-thankyou" && this.prevHeader != this.currentHeader){
        if(document.getElementById("cb-header"))
          document.getElementById("cb-header").$prevHeight = document.getElementById("cb-header").clientHeight + "px";
        this.isNewHeader = true;
      }
      if(document.getElementById("cb-header")){
        document.getElementById("cb-header").$prevHeight = document.getElementById("cb-header").clientHeight + "px";
      }
      this.prevHeader = this.currentHeader;
      return this.currentHeader;
    },
    editMode() {
      return this.$route.query.mode == "edit";
    }
  },
  watch: {
    set_loader(newValue, oldValue) {
      this.showLoader = newValue ? true : false;
    },
    current_notification(newValue, oldValue) {
      if(!newValue) {
        this.showNotification = false;
        return;
      }
      if(newValue.message) {
        this.showNotification = true;
        if(newValue.type == 'error') {
          window.clearTimeout(this.notificationTimeout);
          if(!newValue.isDismissible) {
            this.notificationTimeout = window.cbTimeout(() => this.showNotification = false, ToastNotificationTimeout);
          }
        }
      }
    },
    authenticated(newValue, oldValue) {
      if (oldValue && !newValue) {
        if(this.authType == "email" && this.is_hp_from_plan) {
          this.$router.push({
            name: "check_user"
          });
          this.$store.dispatch('set_current_notification', undefined);
        }
        else {
          this.$router.push({
            name: "error"
          });
        }
      }
    },
    hp_partially_loaded(newValue, oldValue) {
      if(newValue && !oldValue) {
        window.cbPostMessage("cb.loaded");
        document.getElementById("app").focus();
        window.cb_loaded = true;
        window.cbTimeout(() => document.getElementById("app").focus(), 1000);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if(to.name != "choose_pm") {
      next({name: 'choose_pm', params: to.params});
    }
    else {
      next();
    }
  },
  components: {
    "header-1": Type1,
    "header-2": Type2,
    "header-3": Type3,
    "header-thankyou": ThankYouHeader,
    "cb-modal": ModalBox,
    "cb-loader": Loader,
  },
}
</script>
